// extracted by mini-css-extract-plugin
export default {"frame":"PinCompareMap_frame__mMNBA","canvas":"PinCompareMap_canvas__MUEF+","overlay":"PinCompareMap_overlay__n02hG"};